import { render, staticRenderFns } from "./WaterPrice.vue?vue&type=template&id=40822986&scoped=true"
import script from "./WaterPrice.vue?vue&type=script&lang=js"
export * from "./WaterPrice.vue?vue&type=script&lang=js"
import style0 from "./WaterPrice.vue?vue&type=style&index=0&id=40822986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40822986",
  null
  
)

export default component.exports